import React from 'react';

import { Image } from '@swyftx/aviary/atoms/Image';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { SelectItemData } from '@swyftx/aviary/atoms/Select';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';

import { cn } from '@shared/utils/lib/ui';

import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../Command';

type Props = {
  handleValueChange: (value: string) => void;
  isCompact: boolean;
  items: SelectItemData[];
  selectedItem?: SelectItemData;
};

export const Search: React.FC<Props> = ({ isCompact, items, selectedItem, handleValueChange }) => (
  <Command className={cn('p-8', { 'm-0 rounded-b-0 p-0 px-16': isCompact })}>
    <CommandInput
      containerStyles={cn('gap-12 items-center border-b border-color-background-neutral-hover px-12 py-8 pt-0', {
        'bg-color-background-neutral rounded-12 mb-8 items-center pl-12 pb-0': isCompact,
      })}
      className={cn('line-height-20 letter-spacing-base font-sans text-14', { 'py-12': isCompact })}
      placeholder={isCompact ? 'Search for...' : 'Search'}
    />
    <CommandList className={cn('max-h-[24em]', { 'mb-16 h-[65vh]': isCompact })}>
      <CommandEmpty>
        <FlexLayout alignItems='center' justifyContent='center' direction='column' className='gap-4 pb-24 pt-8'>
          <Image image='entity_reviewing' className='h-64 w-64' alt='pending verification' />
          <Heading size='h4'>No results</Heading>
          <Body size='small'>No matching results found</Body>
        </FlexLayout>
      </CommandEmpty>
      <CommandGroup className={cn('cursor-pointer')}>
        {items.map((item) => {
          const sel = item.value === selectedItem?.value;
          return (
            /* [NOTE]: `div` is required here to prevent the CommandItem from
                 lowercasing the value before passing it to onValueChange.
                 This was fixed in cmdk v1.0.0
               * https://github.com/pacocoursey/cmdk/issues/247 */
            <div key={item.value} onClick={() => handleValueChange(item.value)}>
              <CommandItem
                className={cn(
                  'mt-8 cursor-pointer rounded-md px-12 py-8',
                  'aria-selected:bg-color-background-neutral-hover',
                  {
                    'p-0 py-8': isCompact,
                    '!bg-color-background-surface-selected !text-color-text-selected hover:bg-color-background-surface-hover focus:bg-color-background-surface-active focus:outline-0':
                      sel,
                  },
                )}
                value={item.value}
              >
                <Body size='medium' className={cn('px-8')}>
                  {item.label}
                </Body>
              </CommandItem>
            </div>
          );
        })}
      </CommandGroup>
    </CommandList>
  </Command>
);
